import { render, staticRenderFns } from "./PartOfDrawer.vue?vue&type=template&id=b54f762c&lang=pug&"
import script from "./PartOfDrawer.vue?vue&type=script&lang=ts&"
export * from "./PartOfDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./PartOfDrawer.vue?vue&type=style&index=0&id=b54f762c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports